



















import { Component, Mixins } from "vue-property-decorator";
import { NewPageItem } from "../../../../domain/document/items";
import { Geometry, Point } from "../../../../domain/drawing";
import { SvgPathFactory } from "../../../drawing/utilities";
import {
  DraggableLineDrawableObjectMixin
} from "./mixins";
import NewPageDragHandles from "../../../dragging/NewPageDragHandles.vue";
import { IKeyboardEventHandleable, IObjectStyleReadable } from "..";
import { KeyCodeProcessor } from "./KeyCodeProcessor";
import { NewPageObjectStyleReader } from "../styleReaders";

@Component({
  components: {
    NewPageDragHandles,
  }
})
export default class NewpageObject extends Mixins(
  DraggableLineDrawableObjectMixin
) implements IKeyboardEventHandleable {
  editingSource: NewPageItem;
  absoluteGeometry: Geometry;

  get editStyleReader(): IObjectStyleReadable {
    return new NewPageObjectStyleReader();
  }

  get transparentStyleProperties(): any {
    return {
      fill: "transparent",    // transparentで描画する事で、pointerEvents対象とする.)
      strokeWidth: 0,
      pointerEvents: "visiblePainted",
    };
  }

  get from(): Point {
    return this.editingSource.vector.from.subtract(
      this.absoluteGeometry.rectangle.topLeft
    );
  }

  get to(): Point {
    return this.editingSource.vector.to.subtract(
      this.absoluteGeometry.rectangle.topLeft
    );
  }

  get path(): string {
    return SvgPathFactory.createPolyline(this.from, this.to);
  }

  handleKeyboardEvent(event: KeyboardEvent): boolean {
    if (!this.editingSource.isEditable) {
      return false;
    }
    const moveOffset = KeyCodeProcessor.toMoveOffset(event.keyCode);
    if (moveOffset && moveOffset.y) {
      const offset = new Point(0, moveOffset.y);
      this.writeProperty(s => s.vector = s.vector.move(offset));
      return true;
    }
    return false;
  }
}
